import { isErrorStatus, isLoadingStatus, useResource } from 'json-api-hooks';
import React from 'react';

import ErrorCard from '../components/Error/ErrorCard';
import { LoadingCard } from '../components/Loading';
import { ModalProps } from '../components/Modal/ModalContextProvider';
import EventCard from '../models/events/EventCard';

const EventModal = ({ eventId }: ModalProps<{ eventId: string }>) => {
  const [event, status] = useResource({ type: 'events', id: eventId });

  if (isLoadingStatus(status)) {
    return <LoadingCard />;
  }

  if (isErrorStatus(status) || !event) {
    return <ErrorCard />;
  }

  return <EventCard item={event} />;
};

export default EventModal;
